
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Typography, Card, CardContent, Grid, makeStyles } from '@material-ui/core';
import axios from 'axios';
import SearchBox from '../../../../components/table/SearchBox';
import ActionTable from '../../common/serviceTable';
import { CommonConfig } from '../../../../config/common-config';
import Button from '@material-ui/core/Button';


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    container: {
        marginBottom: theme.spacing(1),
    },
    paper: {
        marginBottom: theme.spacing(1),
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        margin: '0px !important',
    },
}));

function ServiceInvoice(props) {
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    // console.log('tennantDetails', tennantDetails);

    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const classes = useStyles();
    const postData = {
        ids: [23],
    };
    const [rows, setRows] = useState([]);
    // console.log('rows', rows);

    const [searchQuery, setSearchQuery] = useState('');
    const dbname = tennantDetails && tennantDetails.tennantName;
    // console.log('dbname', dbname);

    const [searchData, setSearchData] = useState([]);
    const [noRecordCount, setNoRecordCount] = useState(false);
    // const [selectedImc, setselectedImc] = useState([]);
    const [pageDetails, setPageDetails] = useState('');
    const [page, setPage] = useState(0);
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    const headcells = [
        { id: 'clientId', label: 'Client Id' },
        { id: 'clientName', label: 'Client Name' },
        { id: 'employeeId', label: 'Employee Id' },
        { id: 'employeeName', label: 'Employee Name' },
        {
            id: 'servicetypeId',
            label: 'Service Type',
            isConcat: 'true',
            concatElem: ['servicetypeText'],
        },
        { id: 'serviceId', label: 'Service No' },
        { id: 'dateModified', label: 'Date Of Request' },
        // {
        //     id: 'checkList',
        //     label: 'Remarks',
        //     isConcat: 'true',
        //     concatElem: ['remarks'],
        // },

    ];

    function formatDate(props) {
        return props.map((element) => {
            const TempDateCreated = element.checkList.dateModified;
            element.dateModified = TempDateCreated.split(' ', 1);
        });
    }

    const axiosConfig = {
        headers: {
            Authorization: bearerToken,
        },
    };
    useEffect(() => {
        getAdminInvoices();
    }, [tennantDetails, userToken, page]);

    const getAdminInvoices = () => {

        axios
            .post(`${CommonConfig.dev.baseUrl1}/api/itr/service-by-stageid/${dbname}?page=${page}&size=10&sort=checkList.dateModified,desc`, postData, axiosConfig)
            .then((response) => {
                // console.log("'response120'", response.data.content);
                formatDate(response.data.content);
                setRows(response.data.content);
                setPageDetails(response.data);
                setLoading(false);
                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch(() => {
                //console.log(e);
            });
    };




    const handleCount = (val) => {
        if (val === 'prev') {
            if (pageDetails.first !== true) {
                setPage((page) => page - 1);
            }
        }

        if (val === 'next') {
            if (pageDetails.last !== true) {
                setPage((page) => page + 1);
            }
        }
    };

    const handleGenerate = (row) => {

    };

    const getSearchValue = (data) => {
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/itr/service-by-stageid/${dbname}?search=${data}&page=${page}&size=10&sort=checkList.dateModified,desc`, postData, axiosConfig)
            .then((res) => {
                // console.log('responseresponse11', res);
                if (res.data) {
                    if (res.data.content.length === 0) {
                        setRows([]);
                    }
                    formatDate(res.data.content);
                    setRows(res.data.content);
                    setSearchData(res.data.content);
                    setPageDetails(res.data);
                    setLoading(false);
                    if (res.data.first) {
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (res.data.last) {
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                }
            })
            .catch((error) => {
            });
    }

    // handle search item
    const handleSearchQuery = (data) => {
        // console.log(data);
        setSearchQuery(data);
        // console.log('data', data);
        if (data && data.length > 2) {
            setPage(0);
            setNoRecordCount(false);
            getSearchValue(data);
            return true;
        } else {
            setNoRecordCount(true);
        }
        if (!data) {
            setSearchData([]);
            setPage(0);
            getAdminInvoices();
            // useEffect();
        }
    };

    const addInvoice = () => {
        history.push({
            pathname: '/menu/add-invoices',
        });
    }

    const clearField = () => {
        setSearchQuery('');
        setSearchData([]);
        setPage(0);
        getAdminInvoices();
        // useEffect();
        // console.log('clearclear')
    }

    const filteredRow = searchData && searchData.length ? searchData : rows;

    const back = () => {
        history.push({
            pathname: '/menu',
        })
    };

    return (
        <>
            <Card className="custom-table mb10">
                <CardContent className="card-title-display">
                    <Grid item xs={12} sm={8}>
                        <Typography className="card-title">Service Invoices</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} className="card-search">
                        <div className="search-field">
                            <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} clearField={clearField} placeholder="Search..." />
                        </div>

                        <div className="card-add-button">
                            <Button variant="outlined" color="primary" size="small" onClick={addInvoice} className={classes.button}>
                                Request generic invoice
                        </Button>
                        </div>
                    </Grid>
                </CardContent>
                <CardContent className="card-table-display">

                    {rows && filteredRow.length > 0 ? (
                        <>
                            <ActionTable
                                headcells={headcells}
                                handleCount={handleCount}
                                rows={rows}
                                pageDetails={pageDetails}
                                generate={handleGenerate}
                                prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                                action
                                post="admin"
                                mode="generate"
                            />
                        </>
                    ) : (
                            <div className={classes.noRecord}>
                                <h1>No records to display</h1>
                            </div>
                        )}

                </CardContent>
            </Card>
            <Button variant="contained" onClick={() => back()} className="btnBlue txt-cap btnBckFloat" color="primary">
                Back
  </Button>
        </>
    );

}

export default ServiceInvoice;
